import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  breadcrumbItems?: {
    label: string;
    path?: string;
    active?: boolean;
  }[];
  backButton?: {
    path: string;
    label: string;
  };
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, breadcrumbItems = [], backButton }) => {
  const { t } = useTranslation();

  return (
    <div className="page-header">
      <div className="row align-items-center">
        <div className="col">
          <h1 className="page-title">{title}</h1>
          {breadcrumbItems.length > 0 && (
            <ul className="breadcrumb">
              {breadcrumbItems.map((item, index) => (
                <li key={index} className={`breadcrumb-item${item.active ? ' active' : ''}`}>
                  {item.active ? (
                    t(item.label)
                  ) : (
                    <Link to={item.path || '#'}>{t(item.label)}</Link>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
        {backButton && (
          <div className="col-auto">
            <Link to={backButton.path} className="btn btn-primary">
              <i className="ti ti-arrow-left mr-2"></i> {t(backButton.label)}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
